module.exports = __webpack_public_path__ + "img/BackBrand.b510e96.svg";